import { render, staticRenderFns } from "./ConfiguracaoEspecialista.vue?vue&type=template&id=0cbcc894&scoped=true&lang=pug"
import script from "./ConfiguracaoEspecialista.vue?vue&type=script&lang=js"
export * from "./ConfiguracaoEspecialista.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracaoEspecialista.vue?vue&type=style&index=0&id=0cbcc894&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbcc894",
  null
  
)

export default component.exports